import React from 'react';
import { DetectionFieldsFragment } from '../../../../../generated/core-api/graphql-react-query';

export interface DetectionGroup {
    id: string,
    title: string,
    lastOccurrence: number,
    projectId: string;
    detections: DetectionFieldsFragment[],
    displayedAt?: number,
    notificationBadge?: { seen: boolean },
  }

const DetectionGroupContext = React.createContext<DetectionGroup[] | null>(null);

export default DetectionGroupContext;
